import React from "react";

const Footer = () => {
  return (
    <div className="row pt-5">
      <div className="col-sm-6 py-2 text-center">
        <a
          href="https://www.buymeacoffee.com/brapps"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
            alt="Buy Me A Coffee"
            width={"200px"}
          />
          <script
            type="text/javascript"
            src="https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js"
            data-name="bmc-button"
            data-slug="brapps"
            data-color="#FFDD00"
            data-emoji=""
            data-font="Cookie"
            data-text="Buy me a coffee"
            data-outline-color="#000000"
            data-font-color="#000000"
            data-coffee-color="#ffffff"
          ></script>
        </a>
      </div>

      <div className="col-sm-6 text-center">
        <a href="https://play.google.com/store/apps/details?id=io.cpp.quizapp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
          <img
            alt="Get it on Google Play"
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            width="200px"
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
